import { IconSaveSvg } from '../../assets/icons/svgComponents'
import Button from '../button'
import Form from '../form'

import * as S from './styles'
type Props = {
  data: any
  handleClick: () => void
}
const CreateConstruct = ({ data, handleClick }: Props) => {
  return (
    <S.Wrapper>
      <S.Body>
        <S.CreateTitle>
          Cadastro de construto
          <Button
            initialIcon={<IconSaveSvg />}
            className="button-save"
            onClick={handleClick}
          >
            Salvar
          </Button>
        </S.CreateTitle>
        <S.InputsContainer>
          <Form data={data} />
        </S.InputsContainer>
      </S.Body>
    </S.Wrapper>
  )
}
export default CreateConstruct
